import reducers from './reducers'

export { default as contactsTypes } from './types'
export { default as contactsActions } from './actions'
export { default as contactsSelectors } from './selectors'

export default reducers
